import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { FormArray } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs/operators';
import { ActionButton } from '../data-table/models/action-button';
import { HeaderTable } from '../data-table/models/header-table';
import { FormType } from 'src/app/enums/form-type.enum';

@Component({
	selector: 'app-form-table',
	templateUrl: './form-table.component.html',
	styleUrls: ['./form-table.component.scss'],
})
export class FormTableComponent implements OnInit, OnChanges {
	@ViewChild('formTable') formTable!: MatTable<any>;
	@Input() data: any[] = [];
	@Input() headers: Array<HeaderTable> = [];
	@Input() formArray!: any;
	@Input() actions: Array<ActionButton> = [];
	@Output() actionEmitter = new EventEmitter<any>();
	displayedColumns: string[] = [];
	headersToDisplay: Array<HeaderTable> = [];
	dataSource: MatTableDataSource<any> = new MatTableDataSource();
	showActions: boolean = false;
	formTableType = FormType;

	constructor() {}

	ngOnInit(): void {
		this.setupTable();
	}

	ngOnChanges(): void {
		this.setupTable();
	}

	/**
	 * Emits the action clicked.
	 * @param event the event type.
	 * @param element the entity selected in the table.
	 */
	actionClicked(event: ActionButton, element: any, index: number): void {
		this.actionEmitter.emit({ eventName: event.eventName, element, index });
	}

	/**
	 * Setups the initial table render.
	 */
	private setupTable(): void {
		this.displayedColumns = this.headers
			.filter((header) => header.display)
			.map((header) => header.property ?? '');

		if (this.actions.length) {
			this.displayedColumns.push('action');
			this.showActions = true;
		}

		this.headersToDisplay = this.headers.filter((header) => header.display);

		(this.formArray as FormArray).valueChanges
			.pipe(take(1))
			.subscribe((p) => this.setupTable());

		this.dataSource = new MatTableDataSource(
			(this.formArray as FormArray).controls
		);
	}
}
